const NutritionTableFooter = ({ needsAllNutritionDetails }) => {
  return (
    <figcaption className="px-[0.25em] text-[0.75em] leading-4">
      <sup className="align-bottom text-[100%]">*</sup> The % Daily Value (DV) tells you how much a
      nutrient in a serving of food contributes to a daily diet. 2,000 calories a day is used for
      general nutrition advice.
      <br />
      {needsAllNutritionDetails && <sup className="align-bottom text-[100%]">**</sup>}
      {needsAllNutritionDetails && 'Raw ingredients without salt & olive oil'}
    </figcaption>
  );
};

NutritionTableFooter.propTypes = {
  needsAllNutritionDetails: PropTypes.bool.isRequired,
};

export default NutritionTableFooter;
